import { faqAccordion } from '../utils/faq';
import { screenshotsAccordion } from '../utils/screenshots';

document.addEventListener('DOMContentLoaded', function (e) {
  faqAccordion();
  screenshotsAccordion();
});
